<app-heading></app-heading>
<app-navigation></app-navigation>
<app-sidemenu></app-sidemenu>
<router-outlet></router-outlet>
<app-footer></app-footer>
